export default __webpack_public_path__ + "static/New_Zealands_feisty_feathered_patient-3111e072ced85a4585c5a52eff05daa6.jpg";